import * as React from 'react'

const Stats = ({ score, lines }: { score: number, lines: number }) => (
    <dl className="stats">
        <dt>Score</dt>
        <dd>{score}</dd>
        <dt>Lines</dt>
        <dd>{lines}</dd>
    </dl>
)

export default Stats
